import { useMemo } from "react";
import { Currency } from "../../../Reducers/objects/currency";

type Cms = {
    id: number,
    domain: string,
    authentication_required: boolean,
    authentication_required_to_book: boolean,
    authentication_required_to_create_trip: boolean,
    is_active: boolean,
    deactivation_message: string | null,
    localization: {
        locale: number,
        deactivation_message: string | null,
    }[] | null,
    selling_currencies: Currency[] | null,
}

export function useCmsConfig(): Cms | undefined {
    return useMemo(() => {
        const config: {
            quotation_code?: string,
            cms_list?: Cms[],
        } = JSON.parse(localStorage.getItem('config') ?? '{}');
        const cmsConfig = config.cms_list?.find((item) => {
            const domainName = window.location.hostname.startsWith("www.") ?
                window.location.hostname.replace("www.", "") :
                window.location.hostname;
            return item.domain === domainName;
        });
        return cmsConfig;
    }, []);
}
